import React from 'react';
import ServiceBanner from '../../components/ServiceBanner';
import ServicePremimum from '../../components/ServicePremimum';
import ServicePlan from '../../components/ServicePlan';

const Service = () => {
  return (
    <div >
      <ServiceBanner />
      <ServicePremimum />
      <ServicePlan />
    </div>
  );
};

export default Service;
